import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const STORAGE_KEY = "cardmoji_last_route";

// Transient auth routes that should NEVER be saved as "last route" — otherwise
// after sign-in we'd bounce users back into a reset/invite flow they already
// completed. Also used as a read-time sanity check in getSavedRoute.
export const NON_PERSISTED_ROUTES = [
  // "/admin" is already excluded by the path !== "/admin" guard below; the
  // stale "/admin/login" entry was removed (never a real route on this app).
  "/login",
  "/admin/signup",
  "/admin/reset-password",
  "/admin/accept-invite",
];

const isDeniedRoute = (path: string) =>
  NON_PERSISTED_ROUTES.some((denied) => path === denied || path.startsWith(`${denied}/`) || path.startsWith(`${denied}?`));

export const useRoutePersistence = () => {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    // Save admin and platform routes only (not consumer /t/ routes or root)
    if (
      (path.startsWith("/admin/") || path.startsWith("/platform")) &&
      path !== "/admin" &&
      !isDeniedRoute(path)
    ) {
      localStorage.setItem(STORAGE_KEY, path);
    }
  }, [location.pathname]);
};

export const getSavedRoute = (): string | null => {
  const saved = localStorage.getItem(STORAGE_KEY);
  if (!saved) return null;
  // Defense in depth: filter denied routes at read time too, so any pre-existing
  // bad value in localStorage (from before this denylist existed) is ignored.
  if (isDeniedRoute(saved)) {
    localStorage.removeItem(STORAGE_KEY);
    return null;
  }
  return saved;
};
